import { Component, Vue, Watch} from 'vue-property-decorator';
import DataTable, { TableVisibility } from '@/components/data-table/DataTable';
import { Options } from '@/components/mi-dialog/MiDialog';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import CreateDialog from '@/views/Settings/Categories/CreateDialog';
import CreateSubCategoryDialog from '@/views/Settings/Categories/CreateSubCategoryDialog';
import { Category } from '@/models/Category';
import { SubCategory } from '@/models/SubCategory';

@Component<Categories>({
  components: {
    CreateDialog,
    CreateSubCategoryDialog,
  },
})
export default class Categories extends Vue {

  protected selectedCategory: Category | null = null;
  protected isCreatingCategory: boolean = false;
  protected isCreatingSubCategory: boolean = false;

  protected visibility: TableVisibility = {
    title: false,
    checkboxes: false,
    search: true,
  }

  protected mounted() {}

  get tableOptions(): Object {
    return {
      model: new Category().include('subCategories').filter({only_main: true}),
      name: {
        singular: 'Category',
        plural: 'Categories',
      },
      sort: {
        key: 'name',
        order: 'ASC',
      },
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: {
            key: 'name',
            order: 'ASC',
          },
          width: '200px',
        },
        {
          text: 'Shortcode',
          value: 'short_name',
          width: '150px',
          sortable: {
            key: 'short_name',
            order: 'ASC',
          },
        },
        {
          text: 'Subcategories',
          value: 'sub_categories',
          transform: (subCategories: SubCategory[]) => {
            if(!subCategories || !subCategories.length) {
              return '-';
            }

            let string = '';
            subCategories.forEach((subCategory: SubCategory) => {
              string += `<span class="sub-color-pill">${subCategory.name}</span>`
            });

            return string;
          }
        },
      ],
      actions: [
        {
          type: 'edit',
          label: 'edit',
          icon: 'edit',
          action: (datatable: DataTable, category: Category) => {
            this.selectedCategory = category;
            this.isCreatingCategory = true;
          },
        },
        {
          type: 'add',
          label: 'add',
          icon: 'create_new_folder',
          action: (datatable: DataTable, category: Category) => {
            this.selectedCategory = category;
            this.isCreatingSubCategory = true;
          },
        },
        {
          type: 'delete',
          label: 'delete',
          icon: 'delete',
          action: (datatable: DataTable, category: Category) => {
            this.selectedCategory = category;
            this.$store.dispatch('openDialog', this.dialogOptions);
          },
        },
      ],
      add: () => {
        this.selectedCategory = null;
        this.isCreatingCategory = true;
      }
    };
  }

  protected get categoriesDatatable(): DataTable|null {
    const dataTable = this.$refs.categoriesDatatable;
    if(dataTable) {
      return (dataTable as DataTable);
    }

    return null;
  }

  get dialogOptions(): Options {
    return {
      title: (this.selectedCategory as Category).name || 'Confirm deletion',
      text: 'Are you sure you wish to delete this category?',
      type: 'warning',
      buttons: {
        confirm: {
          text: 'Delete',
          action: () => {
            if (!this.selectedCategory) {
              return;
            }

            this.selectedCategory
              .delete()
              .then((response: any) => {
                if (response) {
                  this.categoriesDatatable ? this.categoriesDatatable.refresh(true) : null;
                  this.selectedCategory = null;
                }
              })
              .catch((error: AxiosError) => {
                ErrorHandler.network(error);
              });
          },
        },
        cancel: {
          text: 'Cancel',
          action: () => {
            this.selectedCategory = null;
          },
        },
      },
    };
  }

  @Watch('isCreatingCategory')
  protected isCreatingCategoryChanged() {
    if(!this.isCreatingCategory) {
      this.selectedCategory = null;
    }
  }
}
